import { useCart } from "@shopify/hydrogen";

import { useUTMLink } from "../../hooks/use-utm";
import type { MetaImageData } from "../../types";
import { CartIconWithItemsButton } from "../cart/CartIconWithItemsButton";

export interface FeedLogoProps {
  logo: MetaImageData;
  checkoutEnabled: boolean;
}

export function FeedLogo({ logo, checkoutEnabled }: FeedLogoProps) {
  const link = useUTMLink(logo.url);

  return (
    <div className="lookbook--feed--logo">
      <div />
      <a
        className="lookbook--feed--logo--link"
        href={link}
        target="_blank"
        rel="noopener noreferrer">
        {logo.src?.length ? (
          <img
            className="lookbook--feed--logo--image"
            src={logo.src}
            alt={logo.alt}
          />
        ) : (
          <span>{logo.alt}</span>
        )}
      </a>
      {checkoutEnabled ? <CartIconButton /> : <div />}
    </div>
  );
}

function CartIconButton() {
  const { lines } = useCart();

  return (
    <div style={{ visibility: lines.length > 0 ? "visible" : "hidden" }}>
      <CartIconWithItemsButton />
    </div>
  );
}
